/* ================================================================
    MAIN ENTRY POINT - GLOBAL BUNDLE ("all")

    Loads the flexslider jQuery plugin for its side effects
    (registering on the global jQuery), then runs global setup.
================================================================ */
import "./vendor/jquery.flexslider.js";
import { setup } from "./features/global/index.ts";

setup();
